import { FACILITY_ICONS } from '../config/facilities.js';

const MAX_CARD_BADGES = 5;

export function buildCardBadgesFromFacilities(facilities) {
  const badges = [];
  const facilityIds = new Set();
  const facilityIcons = new Set();

  for (const facility of (facilities || []).flatMap((category) => category?.facilities || [])) {
    const icon = FACILITY_ICONS[facility?.id];

    if (!icon || facilityIds.has(facility.id) || facilityIcons.has(icon)) {
      continue;
    }

    facilityIds.add(facility.id);
    facilityIcons.add(icon);
    badges.push({
      id: String(facility.numericId ?? facility.id),
      badgeName: facility.name || facility.id,
      name: facility.name || facility.id,
      transCode: facility.id,
      icon,
      displayMessage: false,
      showLabel: false,
    });

    if (badges.length === MAX_CARD_BADGES) {
      break;
    }
  }

  return badges;
}
